<template>
  <v-dialog v-model="dialog" max-width="500" @click:outside="cancel">
    <recognition-card
      :recognition="recognition"
      show-cancel
      v-on:cancel="cancel"
    ></recognition-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import RecognitionCard from "@/components/recognition/RecognitionCard";
export default {
  name: "RecognitionDialog",
  components: { RecognitionCard },
  props: {},
  data: () => ({
    dialog: false,
    recognition: {}
  }),
  watch: {},
  computed: {
    ...mapGetters({})
  },
  methods: {
    cancel() {
      this.dialog = false;
    },

    showDialog(recognition) {
      this.dialog = true;
      this.recognition = recognition;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-dialog {
  overflow: inherit;
}
</style>
